module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.exclusiveFaqsData && _vm.exclusiveFaqsData.menu_items), function(faq, index) {
    return _c('li', {
      key: index,
      style: (index < (_vm.exclusiveFaqsData && _vm.exclusiveFaqsData.menu_items && _vm.exclusiveFaqsData.menu_items.length - 1) ? 'border-bottom: 1px solid #a9aaa9;' : '')
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "checked": ""
      }
    }), _vm._v(" "), _c('i'), _vm._v(" "), _c('h5', {
      staticClass: "exc-grey",
      domProps: {
        "innerHTML": _vm._s(faq.question)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "exc-grey-content pl-3 pr-3",
      domProps: {
        "innerHTML": _vm._s(faq.answer)
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-952a9282"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/faqsContent/exclusiveFaqs.vue
// module id = 2561
// module chunks = 24